<template>
    <div class="sidebar sidebar-dark">
        <div class="sidebar-header">
            <img src="../../public/assets/images/akxalogo.png" class="logo me-2" width="150" />
            <router-link to="/dashboard" class="sidebar-logo ml-20">CLIC</router-link>
        </div>
        <div id="sidebarMenu" class="sidebar-body">
            <div class="nav-group show">
                <ul class="nav nav-sidebar">
                    <li class="nav-item">
                        <router-link to="/dashboard" class="nav-link" :class="{ active: isDashboardActive }" @click="isActive('/dashboard')"><i class="ri-dashboard-3-line"></i> <span>Dashboard</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="nav-group show1" v-if="permission('configurations')">
                <a href="javascript:void(0)" class="nav-label"><i class="ri-settings-2-line menu_icon"></i>Configurations</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'clusters.view'">
                        <router-link to="/clusters" class="nav-link" :class="{ active: isClusterActive }" @click="isActive('/clusters')"><i class="ri-command-line"></i> <span>Clusters</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'plants.view'">
                        <router-link to="/plants" class="nav-link"><i class="ri-building-3-line"></i> <span>Plants</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'transporters.view'">
                        <router-link to="/transporters" class="nav-link"><i class="ri-user-shared-line"></i> <span>Transporters</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'products.view'">
                        <router-link to="/products" class="nav-link"><i class="ri-product-hunt-line"></i> <span>Products</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'customers.view'">
                        <router-link to="/customers" class="nav-link"><i class="ri-user-line"></i> <span>Customers</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'packings.view'">
                        <router-link to="/packings" class="nav-link"><i class="ri-red-packet-line"></i> <span>Packings</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'storages.view'">
                        <router-link to="/storages" class="nav-link"><i class="ri-database-2-line"></i> <span>Storages</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'loading_types.view'">
                        <router-link to="/loading_types" class="nav-link"><i class="ri-layout-column-line"></i> <span>Loading Types</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'pallet_sizes.view'">
                        <router-link to="/pallet_sizes" class="nav-link"><i class="ri-archive-stack-line"></i> <span>Pallet Sizes</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'stages.view'">
                        <router-link to="/stages" class="nav-link"><i class="ri-stack-line"></i> <span>Stages</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'reason.view'">
                        <router-link to="/reason" class="nav-link"><i class="ri-book-line"></i> <span>Reasons</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'desiccant.view'">
                        <router-link to="/desiccant" class="nav-link"><i class="ri-water-flash-line fs-18 lh-1"></i> <span>Desiccants</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'suppliers.view'">
                        <router-link to="/suppliers" class="nav-link"><i class="ri-refresh-line"></i> <span>Suppliers</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="nav-group show1" v-if="permission('user_management')">
                <a href="javascript:void(0)" class="nav-label"><i class="ri-user-settings-line menu_icon"></i>User Management</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'role.view'">
                        <router-link to="/role" class="nav-link"><i class="ri-user-settings-line"></i> <span>Role</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'users.view'">
                        <router-link to="/users" class="nav-link"><i class="ri-group-line"></i> <span>Users</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'permissions.view'">
                        <router-link to="/permissions" class="nav-link"><i class="ri-shield-user-line"></i><span>Permissions</span></router-link>
                    </li>
                    
                </ul>
            </div>
            <div class="nav-group show">
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'trips.view'">
                        <router-link to="/trips" class="nav-link" :class="{ active: isTripActive }" @click="isActive('/trips')"><i class="ri-truck-line"></i> <span>Trips</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="nav-group show">
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'pallet_inspections.view'">
                        <router-link to="/pallet_inspections" class="nav-link" :class="{ active: isInspectionActive }" @click="isActive('/pallet_inspections')"><i class="ri-search-eye-line"></i> <span>Pallet Inspection</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="nav-group show">
                <ul class="nav nav-sidebar" v-can="'logs.view'">
                    <li class="nav-item">
                        <router-link to="/logs" class="nav-link" :class="{ active: isLogActive }" @click="isActive('/logs')"><i class="ri-box-3-line"></i> <span>Logs</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="nav-group show1">
                <a href="javascript:void(0)" class="nav-label"><i class="ri-file-text-line menu_icon"></i>Reports</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item">
                        <router-link to="/daily_report" class="nav-link" :class="{ active: isDailyReportActive }" @click="isActive('/daily_report')"><i class="ri-calendar-schedule-line"></i> <span>Daily Report</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/container_stuffing" class="nav-link" :class="{ active: isDailyReportActive }" @click="isActive('/daily_report')"><i class="ri-article-line"></i> <span>Container Stuffing</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/pallet_receipt" class="nav-link" :class="{ active: isDailyReportActive }" @click="isActive('/daily_report')"><i class="ri-file-copy-2-line"></i> <span>Pallet Receipt</span></router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="sidebar-footer">
            <div class="sidebar-footer-top">
                <div class="sidebar-footer-thumb" v-if="$store.getters.user?.avatar">
                    <img :src="$store.getters.user?.avatar" alt="" />
                </div>
                <div class="sidebar-footer-thumb" v-else>
                    <img src="../../public/assets/images/default_user_image.jpg" alt="" />
                </div>
                <div class="sidebar-footer-body">
                    <h6><a href="javascript:void(0)">{{ $store.getters.user?.username}}</a></h6>
                    <p>{{ $store.getters.user.role?.role_name }}</p>
                </div>
                <a id="sidebarFooterMenu" href="#" class="dropdown-link"><i class="ri-arrow-down-s-line"></i></a>
            </div>
            <div class="sidebar-footer-menu">
                <nav class="nav">
                    <router-link to="/profile"><i class="ri-edit-2-line"></i> Edit Profile</router-link>
                    <a href="javascript:void(0)" @click="logout()"><i class="ri-logout-box-r-line"></i> Log Out</a>
                </nav>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                isDashboardActive: false,
                isTripActive: false,
                isLogActive: false,
                isClusterActive: false,
                isInspectionActive:false,
                isDailyReportActive:false,
                permissions: this.$store.getters.permissions,
            };
        },
        watch: {
            $route(to) {
                this.isActive(to.path);
            },
        },
        methods: {
            isActive(tab) {
                this.isDashboardActive = false
                this.isTripActive = false
                this.isLogActive = false
                this.isClusterActive = false
                this.isInspectionActive = false
                this.isDailyReportActive = false
                switch (tab) {
                    case "/dashboard":
                        this.isDashboardActive = true;
                        break;
                    case "/trips":
                        this.isTripActive = true;
                        break;
                    case "/logs":
                        this.isLogActive = true;
                        break;
                    case "/clusters":
                        this.isClusterActive = true;
                        break;
                    case "/pallet_inspections":
                        this.isInspectionActive = true;
                        break;
                    case "/pallet_inspections":
                        this.isDailyReportActive = true;
                        break;
                    default:
                        break;
                }
            },
            logout() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "logout", data: vm.$store.getters.user })
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("logout");
                        vm.$router.push("/");
                        // location.reload();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            permission(ability) {
                
                let permissions = this.$store.getters.permissions;
                if (permissions && permissions.length != 0) {
                    let permission = [];
                    if (ability == "configurations") {
                        permission = permissions.filter(function (el) {
                            return (
                                el.ability.ability == "clusters.view" ||
                                el.ability.ability == "plants.view" ||
                                el.ability.ability == "transporters.view" ||
                                el.ability.ability == "products.view" ||
                                el.ability.ability == "customers.view" ||
                                el.ability.ability == "packings.view" ||
                                el.ability.ability == "storages.view" ||
                                el.ability.ability == "loading_types.view" ||
                                el.ability.ability == "pallet_sizes.view" ||
                                el.ability.ability == "reason.view" ||
                                el.ability.ability == "desiccant.view" ||
                                el.ability.ability == "suppliers.view"||
                                el.ability.ability == "stages.view"
                            );
                        });
                    } else if (ability == "user_management") {
                        permission = permissions.filter(function (el) {
                            return el.ability.ability == "role.view" || el.ability.ability == "users.view" || el.ability.ability == "permissions.view";
                        });
                    }
                    if (permission.length == 0) {
                        return false;
                    } else {
                        return true;
                    }
                }

            },
        },
    };
</script>
<style scoped>
    .sidebar-body .nav-sidebar {
        display: none;
        padding: 0 0 10px !important;
    }
    .sidebar-dark .nav-sidebar .nav-link.active {
        color: white;
        font-weight: 400;
    }
    .sidebar-body .nav-sidebar {
        display: none;
        padding: 0 0 0px !important;
    }
    .menu_icon {
        margin-right: 12px;
        line-height: 1;
        font-size: 20px;
        width: 18px;
        opacity: 0.85;
    }
</style>
